/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-props-no-spreading */
import './configs/firebase';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
// react library for routing
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// antd
import { ConfigProvider } from 'antd';
import viVN from 'antd/lib/locale/vi_VN';
import 'moment/locale/vi';
import 'numeral/locales/vi';
import numeral from 'numeral';
import moment from 'moment';
// redux
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Component
import NotificationAlert from 'react-notification-alert';
import { Spinner, Button } from 'reactstrap';

import AdminLayout from 'layouts/Admin';
// import RTLLayout from 'layouts/RTL';
import AuthLayout from 'layouts/Auth';
import OlympicSGKLayout from 'layouts/OlympicSGK';
import KingOfVocabulary from 'layouts/KingOfVocabulary';
import ClassExam from 'modules/OlympicSGKModule/ClassExam';
import OlympicSGKLayoutBook1 from 'layouts/OlympicSGKBook1';
import OlympicSGKLayoutBook2 from 'layouts/OlympicSGKBook2';
import OlympicSGKLayoutBook3 from 'layouts/OlympicSGKBook3';
import OlympicSGKLayoutBook4 from 'layouts/OlympicSGKBook4';
import OlympicSGKLayoutBook5 from 'layouts/OlympicSGKBook5';
import OlympicSGKLayoutBook8 from 'layouts/OlympicSGKBook8';

import { refNotification } from 'components/RootNotification';

import SSO from 'pages/SSO';
import NotFound from '404';
import LangingPage from './pages/LangingPage';

import { store, persistor } from './modules/store';
import UploadWithQrCode from 'pages/UploadWithQrCode';
import Print_Page from 'pages/Print/Print_Page';
import LoadingMark from 'components/Loading/LoadingMark';
import OfflineBooks from 'modules/Offline/Books';

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

try {
  // MOMENT
  moment.locale('vi');
  // NUMERAL
  numeral.locale('vi');
} catch (err) {
  console.log(err);
}

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div style={{ height: '100vh', backgroundColor: 'white' }} className='d-flex flex-column justify-content-center align-items-center' role='alert'>
      <h2 className='text-danger text-lg font-bold'>Ooops, Có lỗi xảy ra </h2>
      <pre>{error.message}</pre>
      <Button color='primary' className='mt-4' onClick={() => resetErrorBoundary}>
        Thử lại
      </Button>
    </div>
  );
};

export default function App() {
  return (
    <React.Suspense
      fallback={
        <div className='h-100 w-100 d-flex justify-content-center align-items-center'>
          <Spinner />
        </div>
      }
    >
      <DndProvider backend={HTML5Backend}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <ConfigProvider
                locale={viVN}
                // csp={{ nonce: 'YourNonceCode' }}
                // getPopupContainer={(node) => {
                //   if (node) {
                //     return node.parentElement;
                //   }
                //   return document.body;
                // }}
              >
                <div className='rna-wrapper' style={{ zIndex: 999999 }}>
                  <NotificationAlert ref={refNotification} />
                </div>
                <LoadingMark />
                {/* <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onError={(error, info) => {
                    console.log('🚀 error', error);
                    console.log('🚀 info', info);
                  }}
                > */}
                <BrowserRouter>
                  <Switch>
                    <Route path={`/lms/print/:template_name`} component={Print_Page} />
                    {/* <Route path={testBankRoutes} render={(props) => <TestBank {...props} />} /> */}
                    <Route path='/lms' render={(props) => <AdminLayout {...props} />} />
                    <Route path='/auth' render={(props) => <AuthLayout {...props} />} />
                    <Route path='/olympicTA' render={(props) => <KingOfVocabulary {...props} />} />
                    <Route path='/olympicsgk' render={(props) => <OlympicSGKLayout {...props} />} />
                    <Route path='/olympic-class-exam' render={(props) => <ClassExam {...props} />} />
                    <Route path='/offline/books' render={(props) => <OfflineBooks {...props} />} />

                    <Route path='/olympicsgkBook1' render={(props) => <OlympicSGKLayoutBook1 {...props} />} />
                    <Route path='/olympicsgkBook2' render={(props) => <OlympicSGKLayoutBook2 {...props} />} />
                    <Route path='/olympicsgkBook3' render={(props) => <OlympicSGKLayoutBook3 {...props} />} />
                    <Route path='/olympicsgkBook4' render={(props) => <OlympicSGKLayoutBook4 {...props} />} />
                    <Route path='/olympicsgkBook5' render={(props) => <OlympicSGKLayoutBook5 {...props} />} />
                    <Route path='/olympicsgkBook8' render={(props) => <OlympicSGKLayoutBook8 {...props} />} />
                    <Route path='/userid/:userId/bookid/:bookId' component={SSO} />
                    <Route path='/upload/qrcode/:moduleName/:subModuleName/:entityName/:entityId' exact render={(props) => <UploadWithQrCode {...props} />} />
                    <Route exact path='/' render={(props) => <LangingPage {...props} />} />
                    <Route path='*' render={(props) => <NotFound {...props} />} />
                  </Switch>
                </BrowserRouter>
                {/* </ErrorBoundary> */}
              </ConfigProvider>
            </PersistGate>
          </Provider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </DndProvider>
    </React.Suspense>
  );
}
